import { BsFolderSymlinkFill } from "react-icons/bs";
import { BiLinkExternal } from "react-icons/bi";

export const Project = ({ project }) => {
  const { _id, title, description, img, link, repoLink, tech } = project;
  return (
    <div className="project m-4">
      <a href={link} target="_blank">
        <img className="project-img" src={img} alt={title} />
        <p className="title m-v-2">{title}</p>
      </a>
      <p>
        {tech?.map((techItem, i) => (
          <span key={i}>
            {techItem}
            {tech.length != i + 1 && " • "}
          </span>
        ))}
      </p>
      <div className="line-decoration"></div>
      <p>{description}</p>
      <div className="project-footer m-t-2">
        <a href={link} target="_blank" className="btn primary-btn m-r-1">
          <BiLinkExternal />
          <span className="p-l-1">Live</span>
        </a>
        <a href={repoLink} target="_blank" className="btn primary-outline-btn">
          <BsFolderSymlinkFill />
          <span className="p-l-1">Source</span>
        </a>
      </div>
    </div>
  );
};
